export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c4025526-c96a-4ebd-aa01-51f6861bfd30';
export const MODAL_CLOSE_SEC = 2.5;
